import { OfflineQueueModel } from '@/db/models';
import { QueueType, OfflineQueuePayload } from '@/db/models/OfflineQueueModel';
import { OfflineQueueDB } from '@/db/repositories';
import { Action, HeadTypeName } from '@/constants';

// enqueue a mutation for offline processing, ensures only one operation exists per entity by deleting previous ones and preserving the initial mutation intent (e.g., keeping 'CREATE' if it was the first action).
export const enqueueOfflineMutation = async (type: QueueType, action: Action, entityId: string, entityType: HeadTypeName, payload: OfflineQueuePayload): Promise<void> => {
  const existing = await OfflineQueueDB.findByEntity(entityId, type, entityType);

  // preserve the initial action intent
  // if it was already a CREATE, it stays a CREATE.
  // if it was already an UPDATE, it stays an UPDATE.
  // TODO: When DELETE is introduced, this merge logic must become a state machine
  const entityAction = existing ? existing.action : action;

  // explicitly remove previous mutations for this entity to ensure a single record
  if (existing) {
    await OfflineQueueDB.deleteByEntity(entityId, type, entityType);
  }

  const newEntry = new OfflineQueueModel(entityId, entityType, type, entityAction, payload);

  await OfflineQueueDB.update(newEntry);
};
